import React from 'react';
export function EmpathyBlock() {
  return <section className="bg-warm-white-dark py-12 md:py-28 px-6" data-id="element-130">
      <div className="max-w-3xl mx-auto text-center" data-id="element-131">
        <p className="text-xl md:text-2xl text-text-dark font-body leading-relaxed" data-id="element-132">
          If you've recently inherited a home — or you know it's coming — you
          already know the feeling. The paperwork nobody explains. The family
          members with opinions. The attorneys who speak in jargon. The constant
          fear of making a decision that costs you thousands. You didn't ask for
          this responsibility. But it's yours now. This guide was written for
          exactly where you are right now.
        </p>
      </div>
    </section>;
}